export const TABLE_INTERACT_EVENT = ["Filter Column", "Sort Table", "Change Page in Search Results"];